module.exports = __webpack_public_path__ + "static/media/mysql.5fc2eb80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/mysql.jpg
// module id = 95
// module chunks = 0